import { Directive, Output, Input, EventEmitter, HostBinding } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { IAppState } from '../../core/store/store';
import { Subscriber } from 'rxjs/Subscriber';

@Directive({
    selector: '[appCheckRole]'
})
export class CheckRoleDirective {
    @Input() rolesToCheck = ['WRITE'];
    @Output() public rolesChecked = new NewBindingEventEmitter<boolean>();
    @Output() public rolesAvailable = new EventEmitter<string[]>();
    @Output() public rolesMissing = new EventEmitter<string[]>();

    constructor(
        private _store: NgRedux<IAppState>
    ) {
        this.rolesChecked.newBinding.subscribe(this.checkRoles.bind(this));
    }

    private checkRoles() {
        const roles = this._store.getState().userState.userRoles;
        const availableRoles = this.rolesToCheck.filter((role) => roles.includes(role));
        const missingRoles = this.rolesToCheck.filter((role) => !roles.includes(role));
        this.rolesChecked.emit(missingRoles.length === 0);
        if (availableRoles.length > 0) {
            this.rolesAvailable.emit(availableRoles);
        }
        if (missingRoles.length > 0) {
            this.rolesMissing.emit(missingRoles);
        }
    }

}

class NewBindingEventEmitter<T> extends EventEmitter<T> {
    constructor(
        public newBinding = new EventEmitter(),
    ) {
        super();
    }

    _subscribe(subscriber: Subscriber<T>): any {
        super._subscribe(subscriber);
        this.newBinding.emit();
    }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/user/directive/check-role.directive.ts